import React from 'react';
import classnames from 'classnames';
import { IconProps } from './@types';

const FilterDeleteIcon: React.FC<IconProps> = (props) => {
    const { className, fillColor, pathColor } = props;
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={classnames(className)}
        >
            <path
                d="M23 6H10L3 14L10 22H23C23.5304 22 24.0391 21.7893 24.4142 21.4142C24.7893 21.0391 25 20.5304 25 20V8C25 7.46957 24.7893 6.96086 24.4142 6.58579C24.0391 6.21071 23.5304 6 23 6V6Z"
                stroke={pathColor ?? '#001A70'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20 11L14 17"
                stroke={pathColor ?? '#001A70'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14 11L20 17"
                stroke={pathColor ?? '#001A70'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export default FilterDeleteIcon;
